import { render, staticRenderFns } from "./kuaishouVideo.vue?vue&type=template&id=5fefa232"
import script from "./kuaishouVideo.vue?vue&type=script&lang=js"
export * from "./kuaishouVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports